import { _, React, withStyles, StyledProps, CentricTheme } from '@api'

const styles = (theme: CentricTheme) => ({
  footerContent: {
    flexGrow:   0,
    flexShrink: 0,
    flexBasis:  'auto',
    height:     theme.cssVars.titleBarHeight,
    background: 'var(--white)',
    borderTop:  'var(--thin-border)'
  }
})

interface MyProps extends StyledProps {
  /** Boolean for toggling footer class */
  isFooterComponentExist?: boolean
}

@(withStyles as any)(styles)
export class DrawerFooter extends React.Component<MyProps> {
  static defaultProps = {
  }

  render() {
    const {children, classes} = this.props;

    return (
      <div data-type='DrawerFooter' className={classes.footerContent}>
        {children}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/ui/components/DrawerFooter.tsx